import React from 'react';
import 'trade-in/components/InstantEstimateWrapper/Components/ConfirmationMessage/ConfirmationMessage.scss';
import ActionButton from '../ActionButton/ActionButton.jsx';

const ConfirmationMessage = ({ title, description, closeText, onClose }) => {
    return (
        <div className="confirmation-message">
            <div className="confirmation-message-header">
                <icon className="icon-radio-button-on" />
                <h3 className="confirmation-message-header--title">{title}</h3>
            </div>
            <p className="confirmation-message--desc">{description}</p>
            <div className="vehicle-buttons-container">
                <div className="vehicle-buttons">
                    <ActionButton noArrow noPrefix onClick={() => onClose()}>
                        {closeText}
                    </ActionButton>
                </div>
            </div>
        </div>
    );
};

ConfirmationMessage.displayName = 'ConfirmationMessage';

export default ConfirmationMessage;
